import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { Separator } from './ui/separator';
import PlayerCard from './PlayerCard';
import ComparisonCharts from './ComparisonCharts';
import ComparisonSummary from './ComparisonSummary';
import VideoSection from './VideoSection';

function ComparisonResult({ data, videoLoading }) {
  return (
    <div className="space-y-8">
      <Card className="shadow-lg">
        <CardHeader>
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <CardTitle className="text-3xl">Comparison Results</CardTitle>
            <div className="flex flex-wrap gap-2">
              <Badge variant="default" className="text-sm px-3 py-1">
                {data.sport.toUpperCase()}
              </Badge>
              {data.category && (
                <Badge variant="secondary" className="text-sm px-3 py-1">
                  {data.category}
                </Badge>
              )}
            </div>
          </div>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-[1fr_auto_1fr] gap-8 items-start mb-8">
            <PlayerCard player={data.player1} position="left" />
            <div className="hidden md:flex items-center justify-center h-full">
              <div className="flex items-center justify-center w-16 h-16 rounded-full bg-primary/10">
                <span className="text-2xl font-bold text-primary">VS</span>
              </div>
            </div>
            <div className="md:hidden flex items-center justify-center py-4">
              <Separator className="w-full" />
            </div>
            <div className="md:hidden flex items-center justify-center py-2">
              <Badge variant="outline" className="text-lg px-4 py-2">VS</Badge>
            </div>
            <PlayerCard player={data.player2} position="right" />
          </div>
        </CardContent>
      </Card>

      <ComparisonSummary comparison={data.comparison} />

      <ComparisonCharts chartData={data.chart_data} />

      <VideoSection 
        player1={data.player1}
        player2={data.player2}
        mashupVideo={data.mashup_video}
        videoLoading={videoLoading}
        videoStatus={data.video_status}
      />
    </div>
  );
}

export default ComparisonResult;
